import * as React from 'react';
import { Input } from 'semantic-ui-react';

interface Props {
    input: Record<string, any>;
    forceFocus?: boolean;
}

export class TableCellRenderField extends React.PureComponent<Props> {
    inputRef = React.createRef();

    componentDidMount() {
        if (this.props.forceFocus) {
            this.inputRef.current.focus();
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.forceFocus && !prevProps.forceFocus) {
            this.inputRef.current.focus();
        }
    }

    render() {
        const { input } = this.props;

        return (
            <Input
                ref={this.inputRef}
                transparent
                fluid
                {...input}
                style={{
                    border: 'none',
                    position: 'relative',
                    left: -1
                }}
            />
        );
    }
}

export default TableCellRenderField;
